export function capitalizeWords(str: string) {
  let words = str.toLowerCase().split(" ");

  let capitalizedWords = words.map((word) => {
    if (word.length > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }
    return word;
  });

  return capitalizedWords.join(" ");
}
